import React, { useState } from 'react';
import { Box, Button, Container, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography } from '@mui/material';
import { closeBtn, logoMastercard, Visalogo } from '../../../assets/images';
import Grid from '@mui/material/Grid2';
import AddCardDetails from '../../modals/AddCardDetails';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DeleteIcon } from '../../../assets/icons';

const Billing = () => {
  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  const [dialogOpen, setDialogOpen] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  const [showAll, setShowAll] = useState(false);

  const handleToggle = () => {
    if (showAll) {
      setVisibleCount(5); // Show only 5 rows
    } else {
      setVisibleCount(rows.length); // Show all rows
    }
    setShowAll(!showAll); // Toggle the state
  };

  function createData(
    name: string,
    date: string,
    status: string,
    amount: string,
    action: ''
  ) {
    return { name, date, status, amount, action };
  }

  const rows = [
    createData('#912829239239', 'Nov 1, 2024', 'Paid', '$198.00', ''),
    createData('#912829239239', 'Oct 1, 2024', 'Due', '$198.00', ''),
    createData('#912829239239', 'Sep 1, 2024', 'Paid', '$198.00', ''),
    createData('#912829239239', 'Aug 1, 2024', 'Paid', '$198.00', ''),
    createData('#912829239239', 'Jul 1, 2024', 'Paid', '$198.00', ''),
    createData('#912829239239', 'Jul 1, 2024', 'Paid', '$198.00', ''),
    createData('#912829239239', 'Jul 1, 2024', 'Paid', '$198.00', ''),
    createData('#912829239239', 'Jul 1, 2024', 'Paid', '$198.00', ''),
    createData('#912829239239', 'Jul 1, 2024', 'Paid', '$198.00', ''),
  ];



  const CustomTabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  };

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };


  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleConfirm = () => {
    console.log('Confirmed!');
    setDialogOpen(false);
  };

  const currentYear = dayjs()

  return (
    <Container sx={{ maxWidth: "1200px", px: "0 !Important" }}>
      <Box>
        <Box mb={{ xs: "34px", sm: '20px', xl: "34px" }}>
          <Typography color="#333333" fontSize="24px" mb="15px" fontWeight="500">
            Billing
          </Typography>
          <Typography>Manage Billing Information</Typography>
        </Box>

        <Box sx={{ width: '100%' }} className='settings-module-listing'>
          <Box sx={{ borderColor: 'divider' }} display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap="12px">
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Invoices" {...a11yProps(0)} sx={{ textTransform: 'capitalize' }} />
              <Tab label="Billing Info" {...a11yProps(1)} sx={{ textTransform: 'capitalize' }} />
            </Tabs>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                maxDate={currentYear}
                openTo="month"
                views={['year', 'month']}
                yearsOrder="desc"
                className='date-picker-custom'
                sx={{
                  backgroundColor: "#ffffff",
                }}
                slotProps={{
                  textField: {
                    placeholder: 'Filter by Month',
                  },
                  layout: {
                    sx: {
                      minWidth: 246,
                      '.MuiPickersMonth-monthButton.Mui-selected, .MuiPickersMonth-monthButton:hover': {
                        color: '#ffffff',
                        backgroundColor: '#614EFA',
                      },
                      '.MuiPickersYear-yearButton.Mui-selected, .MuiPickersYear-YearButton:hover': {
                        color: '#ffffff',
                        backgroundColor: '#614EFA !important',
                      },
                    }
                  }
                }}

              />
            </LocalizationProvider>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <TableContainer component={Paper} sx={{ boxShadow: '0px 4px 12px 0px #2B2B300F' }}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left" sx={{ textTransform: 'capitalize', color: '#666666', fontSize: '16px', borderBottom: '1px solid #E8EAF0', fontWeight: "400" }}>Invoice Number</TableCell>
                    <TableCell align="left" sx={{ textTransform: 'capitalize', color: '#666666', fontSize: '16px', borderBottom: '1px solid #E8EAF0', fontWeight: "400" }}>Invoice Date</TableCell>
                    <TableCell align="left" sx={{ textTransform: 'capitalize', color: '#666666', fontSize: '16px', borderBottom: '1px solid #E8EAF0', width: '20%', fontWeight: "400" }}>Status</TableCell>
                    <TableCell align="left" sx={{ textTransform: 'capitalize', color: '#666666', fontSize: '16px', borderBottom: '1px solid #E8EAF0', fontWeight: "400" }}>Amount</TableCell>
                    <TableCell align="left" sx={{ textTransform: 'capitalize', color: '#666666', fontSize: '16px', borderBottom: '1px solid #E8EAF0', fontWeight: "400" }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.slice(0, visibleCount).map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="left" component="th" scope="row" sx={{ color: '#231F1F', fontSize: '18px', borderBottom: '1px solid #E8EAF0' }}>
                        {row.name}
                      </TableCell>
                      <TableCell align="left" sx={{ color: '#231F1F', fontSize: '18px', borderBottom: '1px solid #E8EAF0' }}>{row.date}</TableCell>
                      <TableCell align="left" sx={{ color: '#231F1F', fontSize: '18px', borderBottom: '1px solid #E8EAF0' }}> <Box display="flex" gap='6px' alignItems='center'><Box sx={{

                        backgroundColor: row.status === 'Paid' ? '#22B0601A' : row.status === 'Due' ? '#FCEDEF' : 'transparent',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '32px',
                        minWidth: '71px',
                        fontSize: '16px',
                        color: row.status === 'Paid' ? '#22B060' : row.status === 'Due' ? '#E44258' : '#000000',
                      }}>{row.status}</Box> {row.status === 'Due' && <Typography display='flex'> (<Typography color='#178EFC' fontSize='16px'>Pay Now </Typography>)</Typography>}</Box></TableCell>
                      <TableCell align="left" sx={{ color: '#231F1F', fontSize: '18px', borderBottom: '1px solid #E8EAF0' }}>{row.amount}</TableCell>
                      <TableCell align="left" sx={{ cursor: 'pointer' }}><img src={closeBtn} /></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box display='flex' justifyContent="center" mt="24px">
              <Button variant='outlined' size='large' sx={{
                textTransform: 'capitalize', border: '1px solid #614EFA', borderRadius: '8px', color: '#614EFA', "&:hover": {
                  border: "1px solid #614EFA",
                }
              }}
                onClick={handleToggle}>{showAll ? "Load Less" : "Load More"}</Button>
            </Box>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }}>
              <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                <Box boxShadow='0px 4px 12px 0px #2B2B300F' padding='26px' border='1px solid #E8EAF0' bgcolor="#ffffff" display='flex' borderRadius='8px' flexWrap={{ xs: 'wrap', xl: 'unset' }} justifyContent={{ xs: 'flex-end', xl: 'space-between' }}>
                  <Box width={{ xs: '100%', xl: 'unset' }}>
                    <Box>
                      <Typography color='#231F1F' fontSize='20px' fontWeight='500' mb='18px'>Payment Method</Typography>
                    </Box>
                    <Typography color='#666666' fontSize='16px' mb='8px'>Card Information</Typography>
                    <Box display='flex'>
                      <Typography color='#231F1F' fontSize='16px' mb='8px' mr='20px'>Mastercard ending in 4952</Typography>
                      <Box border='1px solid #E8EAF0' padding='5px 20px' borderRadius='4px' width='70px' display='flex' justifyContent='center' alignItems='center' minWidth='70px'>
                        <img src={logoMastercard} alt="" />
                      </Box>

                    </Box>
                    <Box>
                      <Typography color='#666666' fontSize='16px' mb='8px'>Name on Card</Typography>
                      <Typography color='#231F1F' fontSize='16px'>Ryan Lee</Typography>
                    </Box>
                  </Box>

                  <Box >
                    <Button sx={{
                      p: '4px 16px !important',
                      bgcolor: '#333333', color: '#FFFFFF!important', fontWeight: '500', textTransform: 'capitalize', '&:hover': {
                        border: 'none !important'
                      },
                    }}>Default</Button>
                    <Button variant='text' size='large' sx={{ textTransform: 'capitalize', ml: '8px' }}>Update</Button>
                  </Box>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                <Box boxShadow='0px 4px 12px 0px #2B2B300F' padding='26px' border='1px solid #E8EAF0' display='flex' bgcolor="#ffffff" borderRadius='8px' flexWrap={{ xs: 'wrap', xl: 'unset' }} justifyContent={{ xs: 'flex-end', xl: 'space-between' }}>
                  <Box width={{ xs: '100%', xl: 'unset' }}>
                    <Box>
                      <Typography color='#231F1F' fontSize='20px' fontWeight='500' mb='18px'>Billing Details</Typography>
                    </Box>
                    <Typography color='#666666' fontSize='16px' mb='8px'>Next billing detail</Typography>
                    <Box display='flex'>
                      <Typography color='#231F1F' fontSize='16px' mb='8px' mr='20px'>Apr 23, 2025</Typography>

                    </Box>
                    <Box>
                      <Typography color='#666666' fontSize='16px' mb='8px'>Billing Address</Typography>
                      <Typography color='#231F1F' fontSize='16px'>708 W. Summit Ave, San Antonio, Tx. 78201</Typography>
                    </Box>
                  </Box>

                  <Box>
                    <Button variant='text' size='large' sx={{ textTransform: 'capitalize', ml: '8px' }}>Update</Button>
                  </Box>
                </Box>

              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                <Box boxShadow='0px 4px 12px 0px #2B2B300F' padding='26px' border='1px solid #E8EAF0' bgcolor="#ffffff" display='flex' justifyContent='space-between' borderRadius='8px'>
                  <Box display='flex' justifyContent='center' alignItems='center' width='100%' flexDirection='column'>
                    <Box display='flex' gap='40px' mb='40px'>
                      <Box border='1px solid #E8EAF0' padding='5px 20px' borderRadius='4px' width='70px' display='flex' justifyContent='center' alignItems='center' minWidth='70px'>
                        <img src={logoMastercard} alt="" />
                      </Box>
                      <Box border='1px solid #E8EAF0' padding='5px 20px' borderRadius='4px' width='70px' display='flex' justifyContent='center' alignItems='center' minWidth='70px'>
                        <img src={Visalogo} alt="" />
                      </Box>

                    </Box>

                    <Box><Typography color='#000000' fontWeight='500' fontSize={{ xs: '20px', md: '24px' }} mb='21px' maxWidth='295px' margin='auto' textAlign='center' pb='21px'>Add your secondary credit card for payment</Typography>
                      <Typography color='#333333' fontSize='16px' maxWidth='424px' margin='auto' textAlign='center'>This credit card will be used as secondary payment for billing</Typography>

                    </Box>
                    <Box mt='32px'>
                      <Button onClick={handleDialogOpen} sx={{
                        textTransform: 'capitalize', bgcolor: '#614EFA', color: '#FFFFFF !important', px: '24px', height: '40px', borderRadius: '8px', '&:hover': {
                          border: 'none !important'
                        },
                      }}>Add new card</Button>

                      <AddCardDetails
                        open={dialogOpen}
                        onClose={handleDialogClose}
                        title="Dialog Title"
                        content="This is the dialog content."
                        onConfirm={handleConfirm}
                      />

                    </Box>
                  </Box>
                </Box>
              </Grid>

              {/* when click on the add new card button */}
              {/* <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
              <Box boxShadow='0px 4px 12px 0px #2B2B300F' padding='26px' border='1px solid #E8EAF0' bgcolor="#ffffff" display='flex'  borderRadius='8px' flexWrap={{xs:'wrap', xl:'unset'}} justifyContent={{xs:'flex-end' ,xl:'space-between'}}>
                <Box width={{xs:'100%' ,xl:'unset'}}>
                  <Box>
                    <Typography color='#231F1F' fontSize='20px' fontWeight='500' mb='18px'>Payment Method</Typography>
                  </Box>
                  <Typography color='#666666' fontSize='16px' mb='8px'>Card Information</Typography>
                  <Box display='flex'>
                    <Typography color='#231F1F' fontSize='16px' mb='8px' mr='20px'>Visa ending in 4952</Typography>
                    <Box border='1px solid #E8EAF0' height='31px' padding='5px 20px' borderRadius='4px' width='70px' display='flex' justifyContent='center' alignItems='center' minWidth='70px'>
                      <img src={Visalogo} alt="" />
                    </Box>

                  </Box>
                  <Box>
                    <Typography color='#666666' fontSize='16px' mb='8px'>Name on Card</Typography>
                    <Typography color='#231F1F' fontSize='16px'>Ryan Lee</Typography>
                  </Box>
                </Box>

                <Box width={{xl:'70%'}} display='flex' flexWrap='wrap' justifyContent='flex-end' mt={{xs:'20px' ,lg:'unset'}}>
                <Button variant='text' size='large' sx={{ textTransform: 'capitalize', ml: '8px' }}>Set as Default</Button>
                  <Button variant='text' size='large' sx={{ textTransform: 'capitalize', ml: '8px' }}>Update</Button>
                  <Box>
                    <Box mt='7px'>
                    <DeleteIcon></DeleteIcon>
                    </Box>
                
                  </Box>

                </Box>
              </Box>

            </Grid> */}

            </Grid>
          </CustomTabPanel>
        </Box>
      </Box >
    </Container>
  );
};

export default Billing;
